import dayjs from 'dayjs/esm';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';
import { ICbicContentTypeMst } from 'app/entities/cbic-content-type-mst/cbic-content-type-mst.model';
import { ITableViewConfigs } from '../table-view-configs/table-view-configs.model';
import { ICbicInternalDocMapping } from '../cbic-internal-doc-mapping/cbic-internal-doc-mapping.model';

export interface ICbicContentMst {
  id?: number;
  isActive?: string | null;
  orderId?: number | null;
  createdDt?: dayjs.Dayjs | null;
  updatedDt?: dayjs.Dayjs | null;
  createdBy?: number | null;
  updateBy?: number | null;
  versionNo?: number | null;
  isPublished?: string | null;
  publishDt?: dayjs.Dayjs | null;
  isArchived?: string | null;
  archiveDt?: dayjs.Dayjs | null;
  parentId?: number | null;
  taxId?: number | null;
  locationId?: number | null;
  titleEn?: string | null;
  titleHi?: string | null;
  infoEn?: string | null;
  infoHi?: string | null;
  refNumber?: string | null;
  path?: string | null;
  contentDt?: dayjs.Dayjs | null;
  refDt1?: dayjs.Dayjs | null;
  refDt2?: dayjs.Dayjs | null;
  expiryDt?: dayjs.Dayjs | null;
  year?: number | null;
  viewType?: number | null;
  cbicDocMsts?: ICbicDocMst[] | null;
  childContentCount?: number | 0;
  childContentList?: ICbicContentMst[] | null;
  contentType?: ICbicContentTypeMst | null;
  addInfo1En?:string|null;
  addInfo1Hi?:string|null;
  addInfo2En?:string|null;
  addInfo2Hi?:string|null;
  addInfo3En?:string|null;
  addInfo3Hi?:string|null;
  tableViewConfigs?: ITableViewConfigs[] | null;
  internalDocMappings?: ICbicInternalDocMapping[] | null;
}

export class CbicContentMst implements ICbicContentMst {
  constructor(
    public id?: number,
    public isActive?: string | null,
    public orderId?: number | null,
    public createdDt?: dayjs.Dayjs | null,
    public updatedDt?: dayjs.Dayjs | null,
    public createdBy?: number | null,
    public updateBy?: number | null,
    public versionNo?: number | null,
    public isPublished?: string | null,
    public publishDt?: dayjs.Dayjs | null,
    public isArchived?: string | null,
    public archiveDt?: dayjs.Dayjs | null,
    public parentId?: number | null,
    public taxId?: number | null,
    public locationId?: number | null,
    public titleEn?: string | null,
    public titleHi?: string | null,
    public infoEn?: string | null,
    public infoHi?: string | null,
    public refNumber?: string | null,
    public path?: string | null,
    public contentDt?: dayjs.Dayjs | null,
    public refDt1?: dayjs.Dayjs | null,
    public refDt2?: dayjs.Dayjs | null,
    public expiryDt?: dayjs.Dayjs | null,
    public year?: number | null,
    public viewType?: number | null,
    public cbicDocMsts?: ICbicDocMst[] | null,
    public contentType?: ICbicContentTypeMst | null,
    public childContentCount?: number | 0, 
    public childContentList?: ICbicContentMst[] | null,
    public addInfo1En?:string|null,
    public addInfo1Hi?:string|null,
    public addInfo2En?:string|null,
    public addInfo2Hi?:string|null,
    public addInfo3En?:string|null,
    public addInfo3Hi?:string|null,
    public tableViewConfigs?: ITableViewConfigs[] | null,
    public internalDocMappings?: ICbicInternalDocMapping[] | null
  ) {}
}

export function getCbicContentMstIdentifier(cbicContentMst: ICbicContentMst): number | undefined {
  return cbicContentMst.id;
}
